// extracted by mini-css-extract-plugin
export default {"serverError":"ServerErrorFallback_serverError__-flz1","errorMessage":"ServerErrorFallback_errorMessage__Gbkha"};